module.exports = __webpack_public_path__ + "static/media/GiftBackground.43201404.svg";